"use client";

import { SanityFAQ } from "@/sanity/lib/types";
import { ArrowRight } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import Question from "./Question";

interface AboutFAQProps {
  faqs: SanityFAQ[];
}

export default function AboutFAQs({faqs}: AboutFAQProps) {
  const [openQuestion, setOpenQuestion] = useState<number>(-1);


  const faqsSample = faqs;

  function handleOpenQuestion(index: number) {
    if (openQuestion === index) {
      setOpenQuestion(-1);
    } else {
      setOpenQuestion(index);
    }
  }

  return (
    <section className="relative my-20 px-6 md:my-30 lg:my-40">
      <div className="mx-auto flex max-w-260 items-center gap-6 lg:gap-15">
        <div className="hidden w-2/5 lg:block">
          <Image
            src="/faqs-art.webp"
            alt="Thinking illustration"
            width={340}
            height={306}
            className="mt-2 ml-auto h-auto w-85"
          />
        </div>
        <div className="relative self-start lg:w-3/5">
          <h2 className="text-primary flex gap-2 self-start justify-self-center text-center text-2xl font-semibold uppercase lg:justify-self-start lg:text-3xl">
            <Image
              src="/icons/faq.svg"
              alt="faq icon"
              width={25}
              height={25}
              className="hidden md:block"
            />
            Frequently Asked Questions
          </h2>
          <div className="inset-0 lg:absolute lg:top-12">
            { faqsSample.length > 0 ? (
              faqsSample.map((faq, index) => (
                <Question
                  key={faq._id}
                  index={index}
                  question={faq.question}
                  answer={faq.answer}
                  isOpen={openQuestion === index}
                  onQuestionOpen={handleOpenQuestion}
                />
              ))
            ) : (
              <p className="text-gray-500">No FAQs available at the moment.</p>
            )}
            <Link
              href="/faqs"
              className="text-primary mt-8 ml-auto flex max-w-max items-center gap-2 text-2xl font-semibold hover:underline"
            >
              Read more <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
